import Yield from './Yield';

export default Yield;
